import axios from 'axios';
//import history from '../history';
import {CONFIG_API_BE} from '../config';
import Cookies from 'js-cookie';

const user = JSON.parse(localStorage.getItem("user"));
const instance = axios.create({
    baseURL: CONFIG_API_BE.API_MANAGEMENT_HOST,
    headers: {
        'Accept':  'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + (user == null ? Cookies.get('Set-Cookie') : user.access_token)
    }
});

export default instance;